App.controller('SupergroupsController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) {
    "use strict";
     
    $scope.type = 'supergroup';
    $scope.filter = $state.params.filter;
    
    $scope.data = [];
    
    $scope.page = {
        title: 'labels.SUPERGROUPLIST',
        subTitle: ''
    };
    
    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

        

    	if($rootScope.user.id){
            $scope.initialized = true;
    
            $scope.table = {
                loadCallback: function(scope){
                    let response = scope.data
                    $scope.data = response;
                    D.query($scope.type, $scope.filter + '&_withCounters=true', { cache: false }).then(
                        function(response){
                            $scope.table.fields.find(function(f){ return f.name=='words' }).loadingData = false
                            $scope.data = response
                        }
                    ).catch(console.error)
                },
                type: 'supergroup',
                range: -1,
                title: '',
                fields: [
                    {
                        available: true,
                        hasLink: true,
                        name: 'name'
                    },{
                        available: true,
                        name: 'code'
                    },{
                        available: true,
                        name: 'words',
                        type: 'number',
                        loadingData: true
                    }
                ],
                link: {
                    action: 'edit',
                    type: 'supergroup',
                    filter: 'id'
                },
                links: [{
                    link: {
                        action: 'edit',
                        type:'supergroup',
                        filterValue: ''
                    },
                    label: 'labels.SUPERGROUPADDNEW',
                    icon: 'aqi-plus'
                },{
                    link: {
                        action: 'list',
                        type:'groups',
                        filterValue: 'type=CLIENT'
                    },
                    label: 'labels.GROUPS',
                    icon: 'aqi-group'
                }]
            };
        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();
    
  }
  ]);